import { render, staticRenderFns } from "./shelfLife.vue?vue&type=template&id=6207c3a1&scoped=true"
import script from "./shelfLife.vue?vue&type=script&lang=js"
export * from "./shelfLife.vue?vue&type=script&lang=js"
import style0 from "./shelfLife.vue?vue&type=style&index=0&id=6207c3a1&prod&lang=scss&scoped=true"
import style1 from "./shelfLife.vue?vue&type=style&index=1&id=6207c3a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6207c3a1",
  null
  
)

export default component.exports